import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      idKey: 1,
      id: 1,
      name: i18n.t('app.enable'),
      activo: true
    },
    {
      idKey: 2,
      id: 1,
      name: i18n.t('app.disable'),
      activo: false
    },
    {
      idKey: 3,
      id: 2,
      name: i18n.t('app.remove'),
      activo: false
    },
    {
      idKey: 8,
      id: 5,
      name: i18n.t('app.edit_fields'),
      activo: false
    },
    {
      idKey: 12,
      id: 12,
      name: i18n.t('grouping.link_to_group'),
      activo: false
    },
    {
      idKey: 13,
      id: 13,
      name: i18n.t('SEPA.actions.generate_SEPA'),
      activo: false
    },
  ]
}

export function ACCIONES_EMPRESAS (state) {
  return configHelper.getConfig(state, 'ACCIONES_EMPRESAS', GenerateConfig)
}
